module.exports = __webpack_public_path__ + "img/btn_service-1.7827abf8.png";